import { lazy } from 'react';

export const OktaSecurityModule = lazy(() =>
  import('./protected-route/okta-security.tsx').then((module) => ({
    default: module.OktaSecurity,
  })),
);
export const AppModule = lazy(() =>
  import('../App.tsx').then((module) => ({ default: module.App })),
);
export const LayoutWideModule = lazy(() =>
  import('./layout/wide/layout-wide.component.tsx').then((module) => ({
    default: module.LayoutWideComponent,
  })),
);
export const LayoutSidePanelsModule = lazy(() =>
  import('./layout/side-panels-layout/layout-side-panels.component.tsx').then(
    (module) => ({ default: module.LayoutSidePanelsComponent }),
  ),
);
export const UnderConstructionModule = lazy(() =>
  import('./under-construction/under-construction.component.tsx').then(
    (module) => ({ default: module.UnderConstructionComponent }),
  ),
);
export const DemandPageModule = lazy(() =>
  import('./demand/demand-page.component.tsx').then((module) => ({
    default: module.DemandPageComponent,
  })),
);
export const DecompPageModule = lazy(() =>
  import('./decomp/decomp-page.component.tsx').then((module) => ({
    default: module.DecompPageComponent,
  })),
);
export const DecompInsightsPageModule = lazy(() =>
  import('./decomp-insights/decomp-insights-page.component.tsx').then(
    (module) => ({ default: module.DecompInsightsPageComponent }),
  ),
);
export const HomeModule = lazy(() =>
  import('./home/home.component.tsx').then((module) => ({
    default: module.HomeComponent,
  })),
);
export const AboutModule = lazy(() =>
  import('./about/about.component.tsx').then((module) => ({
    default: module.AboutComponent,
  })),
);
export const RecentVisitModule = lazy(() =>
  import('./recentvisits/recentvisits.component.tsx').then((module) => ({
    default: module.RecentVisitComponent,
  })),
);
export const TrainingAndResourcesModule = lazy(() =>
  import('./trainingandresources/trainingandresources.component.tsx').then(
    (module) => ({ default: module.TrainingAndResourcesComponent }),
  ),
);
export const IrisHelpCenterModule = lazy(() =>
  import('./irishelpcenter/irishelpcenter.component.tsx').then((module) => ({
    default: module.IrisHelpCenterComponent,
  })),
);
export const ReleasesModules = lazy(() =>
  import('./releases/releases.component.tsx').then((module) => ({
    default: module.ReleasesComponent,
  })),
);
export const AlertModule = lazy(() =>
  import('./alerts/alerts.component.tsx').then((module) => ({
    default: module.AlertsComponent,
  })),
);
export const CreateAlertModule = lazy(() =>
  import('./alerts/msform.signup.component.tsx').then((module) => ({
    default: module.MsFormSignupComponent,
  })),
);
export const DownloadPageModule = lazy(() =>
  import('./download/download-page.component.tsx').then((module) => ({
    default: module.DownloadPageComponent,
  })),
);
export const SendEmailPageModule = lazy(() =>
  import('./send-email/send-email-page.component.tsx').then((module) => ({
    default: module.SendEmailPageComponent,
  })),
);
export const AlertsPageModule = lazy(() =>
  import('./alerts/alerts-page.component.tsx').then((module) => ({
    default: module.AlertsPageComponent,
  })),
);
export const NetFlowModule = lazy(() =>
  import('./netflow/netflow.component.tsx').then((module) => ({
    default: module.NetFlowComponent,
  })),
);
export const ScenarioPlannerLandingPageModule = lazy(() =>
  import('./scenario-planner/scenario-planner-landing-page.component.tsx').then(
    (module) => ({ default: module.ScenarioPlannerLandingPage }),
  ),
);
export const ScenarioPlannerComparePageModule = lazy(() =>
  import('./scenario-planner/scenario-planner-compare-page.component.tsx').then(
    (module) => ({ default: module.ScenarioPlannerComparePage }),
  ),
);
export const SimpleLayoutModule = lazy(() =>
  import('./layout/simple-layout/simple-layout.component.tsx').then(
    (module) => ({ default: module.SimpleLayoutComponent }),
  ),
);

export const NetflowLayoutModule = lazy(() =>
  import('./netflow/netflow-layout.tsx').then((module) => ({
    default: module.NetflowLayoutComponent,
  })),
);
